export default class ScriptLoaderService {

  // Simplified version of the plugin: https://cdn.ckeditor.com/4.16.0/standard/ckeditor.js
  // Full but without all plugins version: https://cdn.ckeditor.com/4.16.0/full/ckeditor.js
  // Full with all plugins: https://cdn.ckeditor.com/4.16.0/full-all/ckeditor.js
  // Custom AIS build: "https://advantageintegratedsolutions.github.io/ckeditor-dynamic/ckeditor.js"
  // EMERGENCY source backup: 4.16.0/full: https://advantageintegratedsolutions.github.io/ckeditor-full-all-4.16.0/ckeditor.js
  pageScripts = {
    "builder": [
      "https://cdn.ckeditor.com/4.22.1/full-all/ckeditor.js"
      // New: 4.24.0-lts (requires license from here on: CKEditor 4 is EOL since June 2023).
    ],
    "renderer": [
      "https://cdn.ckeditor.com/4.22.1/full-all/ckeditor.js" //required by ViewSource
    ]
  }
  constructor($window, $timeout) {
    'ngInject';
    Object.assign(this, { $window, $timeout});
  }

  importExternalPageScripts(type) {
    let scriptArray = this.pageScripts[type];
    if(!scriptArray) return;

    scriptArray.forEach((path) => {
      const loaded =
      document.querySelectorAll(`script[src='${path}']`).length > 0;
      if (!loaded) {
        let jsTag = document.createElement("script");
        jsTag.type = "text/javascript";
        jsTag.src = path;
        document.body.appendChild(jsTag);
      }
    });
  }

  async waitForLibObject(objectName) {
    while (eval(`window.${objectName}`) === undefined) {
      await new Promise(resolve => this.$timeout(resolve, 20));
    }
    return true;
  }

  async waitForJqueryPlugin(pluginName) {
    while (eval(`$.${pluginName}`) === undefined) {
      await new Promise(resolve => this.$timeout(resolve, 20));
    }
    return true;
  }
}
